import { render, staticRenderFns } from "./ConsultCreate.vue?vue&type=template&id=20aa380a&scoped=true&"
import script from "./ConsultCreate.vue?vue&type=script&lang=js&"
export * from "./ConsultCreate.vue?vue&type=script&lang=js&"
import style0 from "./ConsultCreate.vue?vue&type=style&index=0&id=20aa380a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa380a",
  null
  
)

export default component.exports